import Icon_1 from "../icons/category.svg";

const Logo = function (props) {
  return (
    <a className="logo" href="/">
      <img src={Icon_1} alt="Digital Icon" />
    </a>
  );
};

export default Logo;
